import { render, staticRenderFns } from "./ChatRoomCard.vue?vue&type=template&id=4c947246&scoped=true"
import script from "./ChatRoomCard.vue?vue&type=script&lang=js"
export * from "./ChatRoomCard.vue?vue&type=script&lang=js"
import style0 from "./ChatRoomCard.vue?vue&type=style&index=0&id=4c947246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c947246",
  null
  
)

export default component.exports